import React, { useState } from 'react'
import { Button, Header, Transition } from 'semantic-ui-react'
import Select from 'react-select'
import { AppContext } from './../../../providers'

const selectStyles = {
  option: (provided, state) => ({
    ...provided,
    color: state.isSelected ? 'black' : 'black',
    backgroundColor: state.isSelected ? '#FFFFFF' : '#FFFFFF',
    "&:hover": {
      backgroundColor: state.isFocused ? "#EFEFEF" : "#FFFFFF"
    }
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1;
    const transition = 'opacity 300ms';

    return { ...provided, opacity, transition };
  }
}

const options1 = [
  { value: 'Customer', label: 'Customer' },
  { value: 'Product', label: 'Product' }
];

const options2 = [
  { value: '{{FirstName}}', label: 'FirstName', link: 'Customer' },
  { value: '{{LastName}}', label: 'LastName', link: 'Customer' },
  { value: '{{Age}}', label: 'Age', link: 'Customer' },
  { value: '{{Birthday}}', label: 'Birthday', link: 'Customer' },
  { value: '{{SKU}}', label: 'SKU', link: 'Product' },
  { value: '{{price}}', label: 'Price', link: 'Product' },
  { value: '{{name}}', label: 'Name', link: 'Product' },
  { value: '{{description}}', label: 'Product Description', link: 'Product' },
  { value: '{{image}}', label: 'Image', link: 'Product' },
  { value: '{{link}}', label: 'Buy Now Link', link: 'Product' }
]


const MergeTags = ({ save, close }) => {
  const { theme } = React.useContext(AppContext)

  const [selectedOption, setSelectedOption] = useState({})
  const [selectedOption2, setSelectedOption2] = useState({})

  const filteredOptions = options2.filter((o) => o.link === selectedOption.value)

  const handleChange1 = (selectedOption) => {
    console.log('setting the merge tags...', selectedOption)
    setSelectedOption(selectedOption)
    setSelectedOption2({})
  }

  const handleChange2 = (selectedOption) => {
    console.log('setting the merge tags...', selectedOption)
    setSelectedOption2(selectedOption)
  }

  const onHandleSave = () => {
    console.log('saving the merge tags...', selectedOption2)
    save({
      name: selectedOption2.label,
      value: selectedOption2.value
    })
  }

  const onHandleClose = () => {
    close()
  }

  return (
    <Transition visible={true} animation='scale' duration={500}>
      <div>

          <Header as="h3" style={{ margin: '10px', fontWeight: 'normal' }}><span style={{fontSize: "80%", color: "#999", paddingRight: '10px'}}>Step 1</span> Select the type</Header>
          <Select
            styles={selectStyles}
            value={selectedOption}
            onChange={handleChange1}
            options={options1}
          />
          <Header as="h3" style={{ margin: '10px', fontWeight: 'normal'  }}><span style={{fontSize: "80%", color: "#999", paddingRight: '10px'}}>Step 2</span> Choose a property</Header>
          <Select
            styles={selectStyles}
            value={selectedOption2}
            onChange={handleChange2}
            options={filteredOptions}
          />

        <div
          className="actions"
          style={{ width: '100%', textAlign: 'right', marginTop: '30px' }}>

          <Button inverted={theme.inverted} color={theme.button.primary} onClick={onHandleSave}>
            <i className="save icon"></i> Save
        </Button>
          <Button inverted={theme.inverted} color={theme.button.secondary} onClick={onHandleClose}>
            <i className="close icon"></i> Cancel
        </Button>
        </div>

      </div>
    </Transition>
  )
}

export default MergeTags
